import React from "react";
import {IonAvatar, IonBadge, IonItem, IonLabel} from "@ionic/react";

/**
 * Component displaying a clickable item of the map legend.
 * Is composed of an icon, a label and a badge with a number.
 * @author Alizée Grand
 * @version 1.1
 * @creation 16/09/2021
 * @last_update 05/01/2022
 **/
class MapLegendItem extends React.Component<{
    /**
     * Function called when the user clicks on the item.
     */
    onClick: () => void,
    /**
     * Path to the displayed icon.
     */
    iconUrl: string,
    /**
     * Item label.
     */
    label: string,
    /**
     * Number displayed on the badge.
     */
    nbBadge: number
}> {

    render() {
        return (
            <IonItem color="secondary" button={true} onClick={this.props.onClick} className="legendItem">
                <IonAvatar color="primary" slot="start" className="legendIcon orange-marker">
                    <img src={this.props.iconUrl} alt="Legend icon"/>
                </IonAvatar>
                <IonLabel className="legendLabel">{this.props.label}</IonLabel>
                <IonBadge slot="end" color="primary" className="legendBadge">{this.props.nbBadge}</IonBadge>
            </IonItem>
        );
    }
}

export default MapLegendItem;
